import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { SpinnerComponent } from 'src/app/modules/common/spinner/spinner.component';
import { NEVER, defer} from 'rxjs';
import { finalize, share} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
/**
 * This service is used to manage a loading indicator while the application is interacting with any API (http calls)
 */
export class SpinnerOverlayService {
  private overlayRef: OverlayRef = undefined;

  constructor(private overlay: Overlay) {}

  /**Display a spinner to the user */
  private show(): void {
    Promise.resolve(null).then(() => {
        
        if (!this.overlayRef) {
          const positionStrategy = this.overlay.position().global().top('0');

          this.overlayRef = this.overlay.create(
            {
              //height: '100%',
              //width: '100%',
              hasBackdrop: true,
              positionStrategy,
              panelClass: ['d-flex', 'justify-content-center', 'align-items-center', 'over_layer'],
            }
          );
           this.overlayRef.attach(new ComponentPortal(SpinnerComponent));
        }
    });
  }

  /**Hide the spinner displayed*/
  private hide(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = undefined;
    }
  }

  /**Handle multiple API calls*/
  public readonly spinner$ = defer(() => {
    this.show();
    return NEVER.pipe(
      finalize(() => {
        setTimeout(()=>{this.hide();}, 600);
        
      })
    );
  }).pipe(share());

}